const translations = {
    createdAt: 'Created At',
    lastActivity: 'Last Activity',
    loading: 'Loading',
    name: 'Name',
    noMoreUsers: 'No More Users',
    noUsers: 'No Users',
    roles: 'Roles',
    status: 'Status'
};

export default translations;
